import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'recipientType',
  standalone: false,
})
export class RecipientTypePipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(value: unknown): string {
    if (value === null || value === undefined || value === '') {
      return this.translate.instant('common.unknown');
    }
    const slug = String(value).trim().toLowerCase();
    if (!slug) {
      return this.translate.instant('common.unknown');
    }
    const key = `enums.recipientType.${slug}`;
    const translated = this.translate.instant(key);
    // Missing keys: ngx-translate returns the key string (truthy), so `||` after instant() never falls through.
    return translated !== key
      ? translated
      : this.translate.instant('common.unknown');
  }
}
